import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/+$/, "");
if (!BACKEND_URL) {
  throw new Error("REACT_APP_BACKEND_URL is required");
}
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("fcf_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("fcf_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const money = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const dateIT = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("it-IT");
  } catch {
    return s;
  }
};
